export default "__VITE_PUBLIC_ASSET__5529c90d__"